<script>
export default {
  props: {
    active: {
      type: Number,
      default: 1,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<template>
<div>
  <!-- <div :class="$style.steps">
    <div
      v-for="(step, $index) in list"
      :key="$index + 1"
      :class="[$style.step, { [$style['is-process']]: $index + 1 === active }]"
    >
      <div :class="$style.step__number">{{ $index + 1}}</div>
      <div :class="$style.step__main">{{ step.title}}</div>
    </div>
  </div> -->
    <el-steps 
      :active="active - 1"
      align-center
      class="isStyleBase"
      space="30%"
    >
      <el-step  
        v-for="(step, $index) in list"
        :key="$index + 1"
        :title="step.title"
      >
      </el-step>

    </el-steps>
</div>
</template>

<style lang="scss" module>
@import '@design';
// @import '@src/design/_mixins.scss';
// .steps {
//   display: flex;
//   margin-bottom: 20px;
//   justify-content: center;
//   // width: 60%;

//   // margin-left: 20%;
// }
// .step {
//   display: flex;
//   // flex-basis: 50%;
//   // width: 100%;
//   justify-content: center;
//   // flex-shrink: 1;
//   align-items: center;
//   color: #bebebe;
//   margin-left: 30px;
//   margin-right: 30px;
//   flex-direction: column;
//   position: relative;
//   // &:after {
//   //   &:not(:last-child) {
//   //     content: '';
//   //     position: absolute;
      
//   //   }
//   // }
//   &:last-child {
//     // flex-basis: auto;
//     // flex-grow: 0;
//     // flex-shrink: 0;
//   }
//   &__number {
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     width: 40px;
//     height: 40px;
//     margin-right: 10px;
//     border: 1px solid #bebebe;
//     border-radius: 50%;
//     margin-bottom: 12px;
//   }

//   @include when(process) {
//     color: $color-primary;

//     .step__number {
//       color: $color-primary;
//       border: 1px solid $color-primary;

//     }
//     .step__main {
      
//     }
//   }
// }

:global {
  .isStyleNormal {
    .el-steps {
      &.isStyleBase {
        .el-step {
          &__icon {
            // 圓圈背景顏色不能是透明的原因是因為線會被看到
            background: #fff
          }
        }
      }
    }
  }
  .el-steps {
    &.isStyleBase {
      margin: 1rem 0;
      justify-content: center;
      .el-step {
        &__head {
          &.is-process,&.is-finish {
            .el-step__icon {
              color: $color-primary;
              border: 1px solid $color-primary;
            }
            
          }
          &.is-finish {
            .el-step__line {
              background: $color-primary-light;
              .el-step__line-inner {
                border: 0;
              }
            }
            .el-step__icon {
              color: $color-primary-light;
              border: 1px solid $color-primary-light;
            }
          }
        }
        &__icon {
          width: 40px;
          height: 40px;
          color: #BEC4C6;
          border: 1px solid #BEC4C6;
          // 圓圈背景顏色不能是透明的原因是因為線會被看到
          background: $color-body-bg
        }
        &__line {
          top: 19px;
          height: 1px;
        }
        &__title {
          color: #BEC4C6;
          font-size: 0.875rem;
          font-weight: 400;
          &.is-process {
            color: $color-primary;
          }
          &.is-finish {
            color: $color-primary-light;
          }
        }
      }
    }
  }
}
</style>
